import {
  ToastMessagesUserSettingsKeys,
  UserDTO,
  UserSettingsDataValidation,
} from '@/types/other';
import isStringNotDefined from './is-string-not-defined';
import { isNotOnlyWords } from './is-only-words';
import stringMaxCharacters from './string-max-characters';
import {
  parsePhoneNumberWithError,
  PhoneNumber,
  isValidPhoneNumber,
} from 'libphonenumber-js';
import { isLocaleValid } from './language/language.utils';
import isValidBirthDate from './is-valid-birth-date';
import isStringDefined from './is-string-defined';

const userSettingsDataValidation: UserSettingsDataValidation = (
  user,
  backend = false
) => {
  const {
    firstName = null,
    lastName = null,
    phoneNumber = null,
    userAddress = null,
    dob = null,
    local = null,
    displayPhoneNumber = null,
  } = { ...user };

  const {
    line1 = null,
    city = null,
    countryCode = null,
    postalCode = null,
  } = userAddress ? { ...userAddress } : {};

  let parsedPhoneNumber: PhoneNumber | null = null;

  try {
    parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber || '');
  } catch {
    parsedPhoneNumber = null;
  }

  if (isStringNotDefined(firstName)) {
    return getErrorResult('yourFirstNameCannotBeEmpty');
  }
  if (stringMaxCharacters(firstName, 100)) {
    return getErrorResult('yourFirstNameIsTooLong');
  }
  if (isStringNotDefined(lastName)) {
    return getErrorResult('yourLastNameCannotBeEmpty');
  }
  if (isNotOnlyWords(lastName)) {
    return getErrorResult('yourLastNameIsInvalid');
  }
  if (stringMaxCharacters(lastName, 100)) {
    return getErrorResult('yourLastNameIsTooLong');
  }
  if (isStringNotDefined(phoneNumber)) {
    return getErrorResult('yourPhoneNumberCannotBeEmpty');
  }
  if (!parsedPhoneNumber) {
    return getErrorResult('yourPhoneNumberIsInvalid');
  }
  if (!isValidPhoneNumber(phoneNumber)) {
    return getErrorResult('yourPhoneNumberIsInvalid');
  }
  if (!userAddress) {
    return getErrorResult('yourAddressCannotBeEmpty');
  }
  if (isStringNotDefined(line1)) {
    return getErrorResult('yourAddressCannotBeEmpty');
  }
  if (isStringNotDefined(city)) {
    return getErrorResult('yourCityCannotBeEmpty');
  }
  if (isStringNotDefined(countryCode)) {
    return getErrorResult('yourCountryCannotBeEmpty');
  }
  if (isStringNotDefined(postalCode)) {
    return getErrorResult('yourPostalCodeCannotBeEmpty');
  }
  if (isStringNotDefined(dob)) {
    return getErrorResult('yourDateOfBirthCannotBeEmpty');
  }

  if (!isValidBirthDate(dob)) {
    return getErrorResult('yourDateOfBirthIsInvalid');
  }

  if (local && !isLocaleValid(local)) {
    return getErrorResult('yourLanguageIsInvalid');
  }

  const validatedUser = {
    ...user,
    phoneNumber: parsedPhoneNumber.number,
    displayPhoneNumber:
      backend && isStringDefined(displayPhoneNumber)
        ? displayPhoneNumber
        : phoneNumber,
    local: local ? local.toUpperCase() : 'EN',
  };

  return getValidatedResult(validatedUser);
};

const getErrorResult = (error: ToastMessagesUserSettingsKeys) => {
  return {
    userValidated: null,
    error,
  };
};

const getValidatedResult = (user: UserDTO) => {
  return {
    userValidated: user,
    error: null,
  };
};

export default userSettingsDataValidation;
